
import { Notify } from "quasar";

// utility (can live in same file)
function extractMessage(err: unknown): string {
  // Nuxt $fetch       : err.data.message
  // Axios             : err.response.data.message
  // ofetch/$fetch raw : err.data
  const sources = [
    (err as any)?.response?._data?.message,
    (err as any)?.response?.data?.message,
    (err as any)?.data?.message,
    (err as any)?.data?.error_description,
    (err as any)?.data,
    (err as any)?.message
  ];
  return sources.find((m) => m != null) ?? String(err);
}

export const apiResponseHandler = {
  success(msg: string) {
    Notify.create({ type: "positive", message: msg });
  },
  info(msg: string) {
    Notify.create({ type: "info", message: msg });
  },
  error: (err: unknown, prefix = "Error") => {
    const prefixText = prefix ? `${prefix}: ` : "";
    try {
      const message = extractMessage(err);

      Notify.create({ type: "negative", message: prefixText + message });
    } catch (e) {
      console.log('Error: There was a problem trying to find the actual error message.', e, err)
      Notify.create({ type: "negative", message: prefixText + e });
    }
  },
  notify: Notify.create
}

export function useApiResponseHandler() {
  const success = (msg: string) => {
    Notify.create({ type: "positive", message: msg });
  }
  const info = (msg: string) => {
    Notify.create({ type: "info", message: msg });
  }
  const error = (err: unknown, prefix = "Error") => {
    const prefixText = prefix ? `${prefix}: ` : "";
    try {
      const message = extractMessage(err);

      Notify.create({ type: "negative", message: prefixText + message });
    } catch (e) {
      console.log('Error: There was a problem trying to find the actual error message.', e, err)
      Notify.create({ type: "negative", message: prefixText + e });
    }
  }
  return {
    success,
    info,
    error,
    notify: Notify.create,
    extractMessage
  };
}
